import AuthRegisterForm from "../components/AuthRegisterForm";
import { SEOHead } from "@/components/SEOHead";
import { Store } from "lucide-react";

const Register = () => (
  <>
    <SEOHead
      title="Join Bahama Marketplace - Create Account"
      description="Join Bahama Marketplace today and discover amazing products from local sellers across the beautiful Bahamas."
      keywords="register, create account, Bahama Marketplace signup, Bahamas marketplace"
    />
    <main className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md bg-card p-8 rounded-2xl shadow-lg border">
        <div>
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Store className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-3xl font-bold text-center mb-2">Join Bahama Marketplace</h1>
          <p className="text-muted-foreground text-center mb-8">
            Create your account and start discovering amazing products from local sellers
          </p>
        </div>
        <AuthRegisterForm />
      </div>
    </main>
  </>
);

export default Register;